/**
 * Campos VIRTUALES del loop (helpers de posición), disponibles bajo cualquier alias
 * (ej. `cliente._letra`). Los inyecta el runtime del loop (`buildItemScope`), no son
 * datos del item — por eso son un concepto del MOTOR, no del host.
 */

export interface LoopIndexField {
  key: string
  label: string
}

export const LOOP_INDEX_FIELDS: LoopIndexField[] = [
  { key: '_letra', label: 'Letra (A, B, C…)' },
  { key: '_posicion', label: 'Posición (1, 2, 3…)' },
  { key: '_indice', label: 'Índice (0, 1, 2…)' },
  { key: '_total', label: 'Total de items' },
  { key: '_primero', label: '¿Es el primero? (Sí/No)' },
  { key: '_ultimo', label: '¿Es el último? (Sí/No)' }
]

// Valores de muestra para el panel de detalle / preview.
export const LOOP_INDEX_EXAMPLES: Record<string, string> = {
  _letra: 'A',
  _posicion: '1',
  _indice: '0',
  _total: '2',
  _primero: 'Sí',
  _ultimo: 'No'
}
